if (!customElements.get("m-slideshow-card-flyers")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
      this.initSlider();
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,
        slidesPerView: 4,
        slidesPerGroup: 2,
        spaceBetween: 16,
        loop: true,
        loopAdditionalSlides: 6,
        //effect: "fade",
        // fadeEffect: {
        //   crossFade: true,
        // },
        speed: 1000,
        navigation: this.showArrows
          ? {
              nextEl: this.querySelector(".m-slider-controls__button-next"),
              prevEl: this.querySelector(".m-slider-controls__button-prev"),
            }
          : false,
        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,
        breakpoints: {
          360: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 8,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          992: {
            threshold: 2,
          },
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });

      this.lastSlide = null;
      this.currentSlide = null;
      this.slider && this.slider.on("init", this.handleChange.bind(this));
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      this.slider.init();
      this.bindWheelNav();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    bindWheelNav() {
            if (!this.sliderContainer || !this.slider) return; if (!this.slider._navLockPatched) { this.slider._navLockPatched = true; const _oN = this.slider.slideNext.bind(this.slider); const _oP = this.slider.slidePrev.bind(this.slider); const _sp = () => (this.slider.params.speed || 1000) + 50; this.slider.slideNext = (...a) => { if (this.slider._navLocked) return; this.slider._navLocked = true; _oN(...a); clearTimeout(this.slider._navLockTO); this.slider._navLockTO = setTimeout(() => { this.slider._navLocked = false; }, _sp()); }; this.slider.slidePrev = (...a) => { if (this.slider._navLocked) return; this.slider._navLocked = true; _oP(...a); clearTimeout(this.slider._navLockTO); this.slider._navLockTO = setTimeout(() => { this.slider._navLocked = false; }, _sp()); }; }
      this._wheelLocked = false;
                        this._wheelTimeout = null; this.slider.on("slideChange", () => { clearTimeout(this._loopFixTO); this._loopFixTO = setTimeout(() => { if (this.slider) { this.slider.animating = false; this.slider.loopFix && this.slider.loopFix(); } }, (this.slider.params.speed || 1000) + 50); });
      this.sliderContainer.addEventListener(
        "wheel",
        (e) => {
          const absX = Math.abs(e.deltaX);
          const absY = Math.abs(e.deltaY);
          // Only hijack genuinely horizontal gestures (2-finger trackpad swipe).
          // Leave normal vertical mouse-wheel page scrolling untouched.
          if (absX <= absY || absX < 8) return;
          e.preventDefault();
          if (this._wheelLocked) return;
          this._wheelLocked = true;
          if (e.deltaX > 0) {
            this.slider.slideNext();
          } else {
            this.slider.slidePrev();
          }
          clearTimeout(this._wheelTimeout);
          this._wheelTimeout = setTimeout(() => {
            this._wheelLocked = false;
          }, 700);
        },
        { passive: false }
      );
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const slideType = slides[activeIndex] && slides[activeIndex].dataset.slideType;
      if (this.lastActive !== null) {
        const forcedIndex = this.lastActive;
        this.lastActive = null;
        this.slider.slideToLoop(forcedIndex);
      }
      if (slideType === "video_slide") {
        const video = slides[activeIndex] && slides[activeIndex].querySelector("video");

        if (video) {
          let playPromise = video.play();
          this.lastVideo && this.lastVideo.pause();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.lastVideo = video;
            });
          }
        }
      } else {
        this.lastVideo && this.lastVideo.pause();
        this.lastVideo = null;
      }
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow-card-flyers", MSlideshow);
}
